// import {goTo} from '@utils/route';
// import {homePage} from '@/config';
import {imManager} from '@/common-pages/im/im.state';
import {envConfig} from './env.config';

declare const window: {
  Android: any;
  onNotification: (data: any) => void;
  navigator: Navigator & {
    standalone: boolean;
  };
} & Window;

export const inApp = window?.navigator?.userAgent?.indexOf('Pandora') > -1;

export const inGameBox = window?.navigator?.userAgent?.indexOf('gamebox') > -1;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function isAllowedSafariBrowser(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const ua = window.navigator.userAgent || '';
  const vendor = window.navigator.vendor || '';
  const platform = window.navigator.platform || '';

  const hasSafari = /Safari/i.test(ua);
  const isAppleVendor = vendor === 'Apple Computer, Inc.';
  const isIOSOtherBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
  const isApplePlatform = /Mac|iPhone|iPad|iPod/i.test(platform);

  // 封堵桌面 Chrome DevTools 仅伪造 iOS UA 的情况：若 UA 声称是 iOS 终端，platform 也必须是 iOS
  const isIOSUA = /iPhone|iPad|iPod/i.test(ua);
  const isIOSPlatform = /iPhone|iPad|iPod/i.test(platform);
  const isConsistentIOSDevice = !isIOSUA || isIOSPlatform;

  return (
    hasSafari &&
    isAppleVendor &&
    isApplePlatform &&
    isConsistentIOSDevice &&
    !isIOSOtherBrowser
  );
}

/** 当前访问域名是否在配置的「与 App 等价」白名单内（非 Pandora、不触发原生桥） */
export function isAppEquivalentHost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const allowed = envConfig.appEquivalentHosts;
  if (!allowed.length) {
    return false;
  }
  const host = window.location.hostname.toLowerCase();
  for (const domain of allowed) {
    if (host === domain || host.endsWith(`.${domain}`)) {
      // return isAllowedSafariBrowser();
      return true;
    }
  }
  return false;
}

/** 原生壳、PWA/推广标记、或白名单域名 — 用于下载条/H5 迁移等体验层，勿替代 inApp 调原生 API */
export function isAppLikeExperience(): boolean {
  return inApp || isPWA() || isAppEquivalentHost();
}

const WEB_PWA_PROMO_QUERY_KEYS = ['rb', 'click_clickid'];
const WEB_PWA_PROMO_SESSION_KEY = 'web_pwa_promo_marker';

let webPwaPromoMarker = '';

function getWebPwaPromoMarkerFromSearch(search?: string | null) {
  if (!search) {
    return '';
  }

  try {
    const searchParams = new URLSearchParams(search);
    for (const queryKey of WEB_PWA_PROMO_QUERY_KEYS) {
      const queryValue = searchParams.get(queryKey)?.trim();
      if (queryValue) {
        return queryValue;
      }
    }
    return '';
  } catch (error) {
    return '';
  }
}

function persistWebPwaPromoMarker(marker: string) {
  if (!marker) {
    return;
  }

  webPwaPromoMarker = marker;

  try {
    window.sessionStorage.setItem(WEB_PWA_PROMO_SESSION_KEY, marker);
  } catch (error) {}
}

function hasWebPwaPromoMarker() {
  const currentMarker = getWebPwaPromoMarkerFromSearch(window.location.search);
  if (currentMarker) {
    persistWebPwaPromoMarker(currentMarker);
    return true;
  }

  if (webPwaPromoMarker) {
    return true;
  }

  try {
    const storedMarker =
      window.sessionStorage.getItem(WEB_PWA_PROMO_SESSION_KEY) || '';
    if (storedMarker) {
      webPwaPromoMarker = storedMarker;
      return true;
    }
  } catch (error) {}

  return false;
}

export function isPWA() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true ||
    hasWebPwaPromoMarker()
  );
}

export function getAdjustAttributionFromAPP() {
  const res = window.Android.getAdjustAttribution();
  if (res) {
    try {
      return JSON.parse(res);
    } catch (error) {
      return null;
    }
  }
  return res;
}

export function openURLInAPP(url: string) {
  try {
    window.Android.openURL(url);
  } catch (error) {
    console.log(error);
  }
}

export function openURL(url: string) {
  try {
    // @ts-ignore
    window.jsBridge.postMessage('openWindow', JSON.stringify({url}));
  } catch (error) {}
}

export function getVersion() {
  const res =
    navigator.userAgent.match(/versionCode\/(\d+)/) ||
    navigator.userAgent.match(/AppVersion\/(\d+)/);
  if (res) {
    return res[1];
  }
  return '999';
}

export function getVersionName() {
  const res = navigator.userAgent.match(/versionName\/(.*)\s/);
  if (res) {
    return res[1];
  }
  return getVersion().split('').join('.');
}

export function setPushUniqueUser(id: string) {
  try {
    window.Android.setPushUniqueUser(id);
  } catch (error) {}
}

export function openShare(text: string) {
  try {
    window.Android.shareText(text);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export function getPushToken() {
  try {
    return window.Android.getPushToken();
  } catch (error) {
    return null;
  }
}

type NotificationData = {
  conversationID: string;
  fbSendTime: number;
};
let prevTime = -1;
window.onNotification = function (data) {
  const notifiation: NotificationData = JSON.parse(data || '{}');
  const {conversationID, fbSendTime} = notifiation;
  if (prevTime === fbSendTime) {
    return;
  }
  prevTime = fbSendTime;
  if (conversationID) {
    imManager.setVisibleState(true, {
      customerId: conversationID,
    });
  }
};
